import { useCallback } from 'react';

export const useFileDownload = () => {
  const handleBlobDownload = useCallback((fileBlob: Blob, fileName: string) => {
    if (fileBlob) {
      // Create a URL for the Blob
      const blobUrl = window.URL.createObjectURL(fileBlob);

      // Create an anchor element
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', fileName); // Specify the file name

      // Append the anchor to the body
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up and remove the anchor element
      link.parentNode?.removeChild(link);

      // Revoke the object URL
      window.URL.revokeObjectURL(blobUrl);
    }
  }, []);

  return { handleBlobDownload };
};
